import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { ErrorResponse } from 'react-router';
import { CreateJobRequest, JobSuggestionResponse } from '../../Types/KaziAi';
import { AppSettings } from '../../Utils/Settings';

// API Slice
export const kaziAiApi = createApi({
  reducerPath: 'kaziAiApi',
  baseQuery: fetchBaseQuery({
    baseUrl: AppSettings.ApiBaseUrl,
    prepareHeaders: (headers, { getState }) => {
        headers.set(
            'Authorization',
            `Bearer ${(localStorage.getItem('token') ?? '')}`
        );
        return headers;
    },
  }),
  endpoints: (builder) => ({
    generateJobSuggestion: builder.mutation<JobSuggestionResponse, CreateJobRequest>({
      query: (body) => ({
        url: '/kazi-ai/job-suggestion',
        method: 'POST',
        body,
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        if ('data' in error) {
          return error.data as ErrorResponse;
        }
        return { error: 'An unexpected error occurred' };
      },
    }),
  }),
});

export const { useGenerateJobSuggestionMutation } = kaziAiApi; 